<script setup lang="ts">
import { pageTitle } from '@consumer/logic/v2/header'

const { href } = defineProps<{
  href?: string
}>()

const slots = useSlots()

watchEffect(() => {
  pageTitle.text = slots.default && slots.default()[0].children?.toString()
  pageTitle.href = href
})
</script>

<template>
  <span class="absolute invisible -z-1">
    <slot/>
  </span>
</template>
